import React from 'react';
import featureCheckIcon from '../../assets/img/icons/feature-check.png';
import featureCrossIcon from '../../assets/img/icons/feature-cross.svg';

function FeatureMark({ enabled, label }) {
  return (
    <img
      src={enabled ? featureCheckIcon : featureCrossIcon}
      alt={enabled ? `${label} included` : `${label} not included`}
      className={`nf-plan-feature-mark${enabled ? ' is-on' : ' is-off'}`}
    />
  );
}

export default function PlanFeaturesList({ rows, emptyText = 'No modules in this industry catalog.' }) {
  if (!rows?.length) {
    return <p className="nf-mod-empty">{emptyText}</p>;
  }

  const enabled = rows.filter((r) => r.enabled);
  const disabled = rows.filter((r) => !r.enabled);

  const renderColumn = (heading, items, included) => (
    <div className={`nf-plan-features-col${included ? ' is-included' : ' is-excluded'}`}>
      <p className="nf-plan-features-heading">{heading}</p>
      {items.length > 0 ? (
        <ul className="nf-plan-feature-list">
          {items.map((row) => (
            <li key={row.key} className={included ? 'is-on' : 'is-off'}>
              <FeatureMark enabled={included} label={row.label} />
              <span>{row.label}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="nf-plan-features-empty">None</p>
      )}
    </div>
  );

  return (
    <div className="nf-plan-features nf-plan-features--columns">
      {renderColumn('Included in your plan', enabled, true)}
      {renderColumn('Not in your plan', disabled, false)}
    </div>
  );
}
